import produce from "immer";
import { claimsActions } from ".";
import { IStoreState } from "../initialStoreState";
import { initialClaimsState } from "./claims.types";
import { CLEAR_CLAIMS_STATE, FETCH_CLAIMS_LIST_FAILED, FETCH_CLAIMS_LIST_INPROGRESS, FETCH_CLAIMS_LIST_SUCCESS } from "./claimsActions";
import { LoadState } from "../../constants/enums";

export const claimsReducer = (
  state: IStoreState["claims"] = initialClaimsState,
  action: claimsActions
) => {
  switch (action.type) {
      case FETCH_CLAIMS_LIST_INPROGRESS: {
        const newState = produce(state, (draftState) => {
          draftState.loading = LoadState.InProgress;
          draftState.list = [];
          draftState.totalRecords = 0;
        });
        return newState;
      }
      case FETCH_CLAIMS_LIST_SUCCESS: {
        const { claims, totalRecords } = action.payload;
        const newState = produce(state, (draftState) => {
          draftState.loading = LoadState.Loaded;
          draftState.list = claims;
          draftState.totalRecords = totalRecords;
        });
        return newState;
      }
      case FETCH_CLAIMS_LIST_FAILED: {
        const newState = produce(state, (draftState) => {
          draftState.loading = LoadState.Failed;
          draftState.list = [];
          draftState.totalRecords = 0;
        });
        return newState;
      }


      case CLEAR_CLAIMS_STATE: {
        return initialClaimsState;
      }
  
    default: {
      return state;
    }
  }
};
